import React, { useState, useEffect } from "react";
import "../../styles/NotificationBox.css";
import Skeleton from "../common/Skeleton";
import ApplicationDetailDrawer from "../../modal/ApplicationDetailDrawer";
import api from "../../../shared/AxiosConfig";
import { ApplicationDTO } from "../../../core/dto";
import { tEnum } from "../../../config/translations";

const NotificationBox = ({ title, status, onRefresh }) => {

    const [loading, setLoading] = useState(true);
    const [applications, setApplications] = useState([]);

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);

    useEffect(() => {
        load();
    }, [status]);

    // 🔥 TÜM BOXLARI YENİLEME LİSTENER
    useEffect(() => {
        const refreshListener = () => load();
        window.addEventListener("refresh-notifications", refreshListener);
        return () => window.removeEventListener("refresh-notifications", refreshListener);
    }, []);

    async function load() {
        try {
            setLoading(true);

            const res = await api.get("/application", {
                params: { status, limit: 10 }
            });

            const list =
                res?.data?.data ||
                res?.data?.items ||
                res?.data ||
                [];

            setApplications(list.map(ApplicationDTO.list));

        } catch (e) {
            console.error("Notification load failed", e);
            setApplications([]);
        }

        setLoading(false);
    }

    // ================= DETAIL OPEN =================
    const handleOpenDetail = async (app) => {
        setOpen(true);
        setSelected(null);
        setDetailLoading(true);

        try {
            const res = await api.get("/application", {
                params: { publicId: app.publicId }
            });

            const raw =
                res?.data?.data ||
                res?.data?.items?.[0] ||
                res?.data?.[0] ||
                res?.data;

            const detail = ApplicationDTO.detail(raw);
            setSelected(detail);

        } catch (e) {
            console.error("Detail load failed", e);
        }

        setDetailLoading(false);
    };

    const formatDate = (date) =>
        date
            ? new Date(date).toLocaleString("tr-TR", {
                day: "2-digit",
                month: "long",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            })
            : "-";

    return (
        <>
            <div className="notification-box bg-white border rounded mt-3 p-3">

                {loading ? (
                    <div className="mb-3">
                        <Skeleton height={22} width="35%" />
                    </div>
                ) : (
                    <h5 className="mb-3 border-bottom">{title}</h5>
                )}

                {loading ? (
                    [1,2,3].map(i => (
                        <div key={i} className="mb-3">
                            <Skeleton height={60}/>
                        </div>
                    ))
                ) : applications.length === 0 ? (
                    <div className="text-muted text-center py-2 border-bottom empty-state">
                        Kayıt bulunamadı
                    </div>
                ) : (
                    applications.map(app => (
                        <div
                            key={app.publicId}
                            className="border-bottom py-2 mt-2 notification-item"
                            onClick={() => handleOpenDetail(app)}
                        >
                            <div className="d-flex justify-content-between align-items-start">

                                <div>
                                    <strong>{app.fullName}</strong>
                                    <div className="small mt-1">
                                        {app.phone}
                                    </div>
                                </div>

                                <div className="text-end">
                                    <div className="small">
                                        {tEnum("STATUS", app.status)}
                                    </div>

                                    <div style={{fontSize:"11px", marginTop:"6px"}}>
                                        {formatDate(app.createdAt)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <ApplicationDetailDrawer
                open={open}
                onClose={() => {
                    setOpen(false);
                    load();          // kendi listesini yenile
                    onRefresh?.();   // 🔥🔥 dashboard yenile
                }}
                data={selected}
                loading={detailLoading}
            />

        </>
    );
};

export default NotificationBox;
